export default {
    ZERO: '0',
    ONE: '1',
    TWO: '2',
    THREE_PLUS: '3+',
};
